<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    nav.top-navigation{
        background-color: #FFFFFF;
        height: 75px;
        box-shadow: 0 2px 4px 0 rgba(3, 27, 78, 0.1);
        z-index: 9999;
        position: fixed;
        top: 0;
        left: 0;
        right: 0;

        img.logo{
            margin: auto;
            margin-top: 26.5px;
            margin-bottom: 26.5px;
            width: 181px;
            display: block;
        }

        &:after{
            content: "";
            display: table;
            clear: both;
        }

        span.development-label {
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: #fff;
            background-color: #dc3545;
            padding: 0.25rem 0.875rem;
            border-radius: 5px;
            font-weight: bold;
            float: left;
            margin-top: 22px;
            margin-left: 10px;
        }
    }

    div#app-layout {
        .fade-enter-active, .fade-leave-active {
            transition: opacity .2s;
        }
        .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
            opacity: 0;
        }
    }

    div.cookie-container {
        margin-top: 100px;
        margin-bottom: 100px;

        h1 {
            font-size: 2rem;
        }

        h2 {
            font-size: 1.25rem;
        }

        a {
            color: $secondary-color;

            &:hover {
                color: lighten($secondary-color, 15%);
            }
        }
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        nav.top-navigation{
            img.logo{
                margin-top: 29.5px;
                margin-bottom: 29.5px;
                width: 150px;
            }

            span.development-label {
                display: none;
            }
        }

        div.cookie-container {
            h1 {
                font-size: 1.5rem;
            }
        }
    }
</style>

<template>
    <div id="app-layout">
        <transition name="fade">
            <flash-message v-show="flashMessage"/>
        </transition>

        <nav class="top-navigation">
            <div class="grid-x">
                <div class="large-4 medium-4 small-4 cell">
                    <span class="development-label" v-if="app_env == 'local' || app_env == 'development'">
                        Testovací prostředí
                    </span>
                </div>

                <div class="large-4 medium-4 small-4 cell">
                    <router-link :to="{ name: 'login'}">
                        <img src="/img/logo-navigation-drivalia.svg" class="logo" alt="Drivalia" />
                    </router-link>
                </div>

                <div class="large-4 medium-4 small-4 cell">
                    <lang-switcher />
                </div>
            </div>
        </nav>

        <router-view></router-view>

        <div class="cookie-container grid-container">
            <div class="margin-top-3">
                <div class="margin-bottom-3">
                    <h1><span>{{ $t('cookie.heading') }}</span></h1>

                    <div class="margin-top-3">
                        <p v-html="$t('cookie.mainContent')"></p>
                        <p><strong>{{ $t('cookie.whatIsHeading') }}</strong><br><span v-html="$t('cookie.whatIsContent')"></span></p>
                        <p><strong>{{ $t('cookie.whichCookiesHeading') }}</strong><br><span v-html="$t('cookie.whichCookiesContent')"></span></p>
                    </div>
                </div>

                <div class="margin-bottom-3">
                    <div class="margin-top-3">
                        <p><strong>{{ $t('cookie.howManageHeading') }}</strong><br><span v-html="$t('cookie.howManageContent')"></span></p>
                        <p><strong>{{ $t('cookie.otherTechnologiesHeading') }}</strong><br><span v-html="$t('cookie.otherTechnologiesContent')"></span></p>
                        <ul>
                            <li>{{ $t('cookie.otherTechnologiesNumberOfVisits') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesLastVisit') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesFirstVisit') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesExternalIpAddress') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesInternalIpAddress') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesScreenResolution') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesGeolocation') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesPerformanceBenchmark') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesBandwidthBenchmark') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesUserAgent') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesCapabilities') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesOperatingSystem') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesPluginsInstalled') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesBrowserLanguage') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesFlash') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesTimeOnFile') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesKeywords') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesPagesVisited') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesLengthOfVisit') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesReferralPage') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesMouseCursorPosition') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesMouseClicks') }}</li>
                            <li>{{ $t('cookie.otherTechnologiesScrollPosition') }}</li>
                        </ul>
                        <p v-html="$t('cookie.otherTechnologiesParagraph')"></p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import FullscreenLoader from "../components/global/FullscreenLoader";
    import FlashMessage from '../components/global/FlashMessage.vue'
    import LangSwitcher from "../components/global/LangSwitcher.vue";
    import {ROAST_CONFIG} from "../config";

    export default {
        components: {
            FullscreenLoader,
            FlashMessage,
            LangSwitcher
        },

        data() {
            return {
                app_env: ROAST_CONFIG.APP_ENV,
            }
        },

        computed: {
            ...mapState({
                flashMessage: state => state.flashMessage.data.show
            }),
        },

        created() {

        },

        mounted() {

        },

        methods: {

        }
    }
</script>
